import { useInView } from "react-intersection-observer";

export const useLazyLoad = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
    rootMargin: '150px 0px',
  });
  return { ref, inView };
};
